module.exports = __webpack_public_path__ + "media/main_song.bdd342d6.mp3";